import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EPINIO_TYPES } from '../types';
import { useStore } from 'vuex';
import DataTable from '../components/tables/DataTable.vue';
import type { DataTableColumn } from '../components/tables/types';
import BadgeStateFormatter from '@shell/components/formatter/BadgeStateFormatter.vue';
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'appcharts',
  props: {
    schema: {}
  },
  setup(__props: any) {

const pending = ref<boolean>(true);
 // Keep for compatibility

const store = useStore();

onMounted(async () => {
  await store.dispatch(
    `epinio/findAll`,
    { type: EPINIO_TYPES.APP_CHARTS }
  );
  pending.value = false;
  startPolling(["appcharts"], store);
});

onUnmounted(() => {
  stopPolling(["appcharts"]);
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.APP_CHARTS);
});

const columns: DataTableColumn[] = [
  {
    field: 'meta.name',
    label: 'Name'
  },
  {
    field: 'description',
    label: 'Description'
  },
  {
    field: 'helm_chart',
    label: 'Helm Chart'
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTable, {
    rows: rows.value,
    columns: columns,
    loading: pending.value
  }, {
    "cell:stateDisplay": _withCtx(({ row }) => [
      _createVNode(BadgeStateFormatter, {
        row: row,
        value: row.stateDisplay
      }, null, 8, ["row", "value"])
    ]),
    _: 1
  }, 8, ["rows", "loading"]))
}
}

})